module.exports = __webpack_public_path__ + "static/img/4-4.2918b9b1.jpeg";